var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PEC_text"},[_c('pre',{domProps:{"innerHTML":_vm._s(_vm.text)}},[_vm._v("  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }